<template>
	<section class="view-feed-advertisement">
		<header>
			<h6 class="h7">Sponsored</h6>
		</header>

		<!-- <figure>
			<img src="@/Asset/image/fpo/advertisement-hsunami.jpg" alt="Advertisement" />

			<div class="actions">
				<button class="control type-right">Go</button>
			</div>

			<figcaption>
				<h5>Advertisement</h5>
				<p class="small">Some text about the advertisement</p>
			</figcaption>
		</figure> -->

		<figure v-bind:key="imageUrl" v-if="imageUrl">
			<picture>
				<img v-bind:src="imageUrl" />
			</picture>

			<div class="actions">
				<button class="control type-right" v-on:click="Handle_OnClickGo">Go</button>
			</div>

			<figcaption>
				<h6>{{ advertisementModel.getCompany() }}</h6>
				<p class="small">{{ advertisementModel.getCaption() }}</p>
			</figcaption>
		</figure>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedAdvertisement extends ViewBase {
		/**
		 * @type ChalkySticks.Collection.Advertisement
		 */
		protected get advertisementCollection(): ChalkySticks.Collection.Advertisement {
			return ChalkySticks.Factory.Advertisement.collection();
		}

		/**
		 * @type ChalkySticks.Model.Advertisement
		 */
		protected advertisementModel: ChalkySticks.Model.Advertisement = ChalkySticks.Factory.Advertisement.model();

		/**
		 * @type string
		 */
		protected imageUrl: string = '';

		/**
		 * @type ChalkySticks.Model.Advertisement
		 */
		@mounted
		protected async setupAdvertisement(): Promise<void> {
			// Load collection of ads
			await this.advertisementCollection.fetch();

			// Get today's index
			const index = this.todaysInteger(this.advertisementCollection.length);

			// Select one
			this.advertisementModel = this.advertisementCollection.at(index);
			this.imageUrl = this.advertisementModel.getImage();
		}

		/**
		 * @param number max
		 * @return number
		 */
		protected todaysInteger(max: number = 0): number {
			const date = new Date()
				.toISOString()
				.split('T')[0]
				.replace(/[^0-9]/g, '')
				.split('')
				.reduce((acc, value) => acc + parseInt(value), 0);

			return date % max;
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param Event e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickGo(e: Event): Promise<void> {
			e.preventDefault();

			window.open(this.advertisementModel.getUrl(), '_blank');
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-feed-advertisement {
		padding: 2em 0;
		text-align: center;

		figure {
			margin: 0 auto;
			max-width: 70%;

			picture {
				aspect-ratio: 16 / 9;
				background: rgba(0, 0, 0, 0.25);
				display: block;
				position: relative;
				width: 100%;

				img {
					height: 100%;
					left: 0;
					object-fit: cover;
					position: absolute;
					top: 0;
					width: 100%;
				}
			}

			img {
				border-radius: 4px;
			}

			figcaption {
				text-align: left;
				padding: 1em 0;
			}

			.actions {
				float: right;
				margin-right: -1em;
				padding: 1em;
			}
		}
	}
</style>
